/* Publish by EComposer at 2024-06-07 17:38:01*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-8vfb1xi6cq5"]=  window.__ectimmers["ecom-8vfb1xi6cq5"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-8vfb1xi6cq5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8vfb1xi6cq5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l8eafsycolb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l8eafsycolb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yhq67p0wid').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yhq67p0wid', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pk3r8yebhqs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pk3r8yebhqs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-99g5ftmsceq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-99g5ftmsceq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-znuxa6166ag').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-znuxa6166ag', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-le4mmj0fzrd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-le4mmj0fzrd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6v8of13o4fp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6v8of13o4fp', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-cyvm8zqggug"]=  window.__ectimmers["ecom-cyvm8zqggug"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}

                    });
                    
                        document.querySelectorAll('.ecom-cyvm8zqggug').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cyvm8zqggug', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qu1v2alccnl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qu1v2alccnl', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mphprzny7oe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mphprzny7oe', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0wqryckjllko').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0wqryckjllko', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xmntxh69huf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xmntxh69huf', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5b1jlmmr0zr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5b1jlmmr0zr', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b6i34t0fudg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b6i34t0fudg', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-46skreekf9e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-46skreekf9e', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7087f6yvr16').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7087f6yvr16', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4kjczx6bdi2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4kjczx6bdi2', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 try{
 try{
 try{
 try{
 
} catch(error){console.error(error);}
} catch(error){console.error(error);}
} catch(error){console.error(error);}
} catch(error){console.error(error);}
} catch(error){console.error(error);}